import { render, staticRenderFns } from "./ExpiredDepots.vue?vue&type=template&id=17c1cc69&scoped=true"
import script from "./ExpiredDepots.vue?vue&type=script&lang=js"
export * from "./ExpiredDepots.vue?vue&type=script&lang=js"
import style0 from "./ExpiredDepots.vue?vue&type=style&index=0&id=17c1cc69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c1cc69",
  null
  
)

export default component.exports